import { gql } from "@apollo/client";

export const GET_ATTENDEES = gql`
  query attendees(
    $where: attendees_bool_exp
    $order_by: [attendees_order_by!]
    $limit: Int!
    $offset: Int!
  ) {
    attendees(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      first_name
      last_name
      phone_number
      validation_code
      created_at
      updated_at
      email
      is_suspended
      is_active
      note
      event_id
      event {
        name
      }
      optional_datas
      card_on_files(where: { is_active: { _eq: true } }, order_by: { created_at: desc }, limit: 1) {
        id
        last_four_digits
        card_type
        is_active
      }
      __typename
    }
  }
`;

export const GET_ATTENDEES_ALL = gql`
  query attendeesAll($where: attendees_bool_exp, $order_by: [attendees_order_by!]) {
    attendees(where: $where, order_by: $order_by) {
      id
      first_name
      last_name
      phone_number
      validation_code
      created_at
      updated_at
      email
      is_suspended
      is_active
      note
      event_id
      event {
        name
      }
      optional_datas
      card_on_files(where: { is_active: { _eq: true } }, order_by: { created_at: desc }, limit: 1) {
        id
        last_four_digits
        card_type
        is_active
      }
      __typename
    }
  }
`;

/**
 * Two counts in one round trip: everything matching the base filters, and the
 * subset that has an active card on file. "Without card" is derived by subtraction
 * (EXISTS / NOT EXISTS partition the set exactly).
 */
export const GET_ATTENDEES_STATS = gql`
  query attendeesStats($where: attendees_bool_exp, $withCard: attendees_bool_exp) {
    all: attendees_aggregate(where: $where) {
      aggregate {
        count
      }
    }
    with_card: attendees_aggregate(where: $withCard) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_ATTENDEE = gql`
  query attendeesByPk($id: Int!) {
    attendees_by_pk(id: $id) {
      id
      first_name
      last_name
      phone_number
      created_at
      updated_at
      email
      validation_code
      personnal_pin
      event_id
      event {
        id
        name
      }
      is_suspended
      is_active
      note
      optional_datas
    }
  }
`;


export const GET_ATTENDEE_DETAIL = gql`
  query attendeesByPk($id: Int!) {
    attendees_by_pk(id: $id) {
      id
      first_name
      last_name
      phone_number
      created_at
      updated_at
      email
      validation_code
      event_id
      is_suspended
      is_active
      note
    }
  }
`;

export const GET_ATTENDEE_RFID = gql`
  query GET_ATTENDEE_RFID($id: Int!, $event_id: Int!) {
  rfid_assets(where: {attendee_id: {_eq: $id}, event_id: {_eq: $event_id}}, order_by: {uid: asc}) {
    id
    is_active
    is_qr
    uid
    reg_id
    tokens_balance
  }
}
`;
export const GET_ATTENDEE_CARD = gql`
  query attendeesRfidCard($id: Int!, $event_id: Int!) {
    card_on_files(where: {attendee_id: {_eq: $id}, event_id: {_eq: $event_id}}, order_by: {updated_at: desc}) {
      id
      last_four_digits
      is_active
    }
  }
`;

export const GET_ATTENDEE_ORDERS = gql`
query attendeeOrders($event_id: Int!, $uids: [String!]) {
  reports_transactions(where: {event_id: {_eq: $event_id}, uid: {_in: $uids}}, order_by: {transaction_time: desc}) {
    card_type
    device_app_id
    digital_surcharge
    event_id
    event_name
    applied_discount_amount
    item_subtotal
    last4
    location_id
    location_name
    order_id
    order_items_count
    order_mx_ref_id
    order_status
    organization_id
    organization_name
    payment_ref_id
    order_payment {
      reference_id
    }
    payment_status
    payment_type
    applied_discount_name
    tax
    tip
    transaction_amount
    transaction_date
    transaction_hour
    transaction_status
    transaction_time
    uid
    attendee_id
    email
    username
    vendor_id
    vendor_name
  }
}
`;

export const GET_ATTENDEE_ORDERS_BY_ATTENDEE = gql`
query attendeeOrders($event_id: Int!, $attendeeId: Int!) {
  reports_transactions(where: {event_id: {_eq: $event_id}, attendee_id: {_eq: $attendeeId}}, order_by: {transaction_time: desc}) {
    applied_discount_amount
    applied_discount_name
    attendee_id
    build_id
    card_type
    created_at
    device_app_id
    digital_surcharge
    discount_json
    email
    event_id
    event_name
    is_tab
    item_subtotal
    items_json
    last4
    location_id
    location_name
    order_id
    order_items_count
    order_mx_ref_id
    order_status
    organization_id
    organization_name
    payment_ref_id
    order_payment {
      reference_id
    }
    payment_status
    payment_type
    promo_code_uid
    tab_name
    tab_nickname
    tax
    tip
    total_promo_discount
    transaction_amount
    transaction_date
    transaction_hour
    transaction_status
    transaction_time
    uid
    username
    vendor_id
    vendor_name
  }
}
`;

export const GET_ATTENDEE_PROMO_CODES = gql`
  query attendeePromoCodes($attendeeId: Int!) {
    promo_code(where: {attendee_id: {_eq: $attendeeId}}, order_by: {created_at: desc}) {
      id
      uid
      description
      promo_code_type
      promo_payload
      balance
      unlimited_usage
      is_used
      created_at
      updated_at
      event {
        id
        name
      }
    }
  }
`;

export const GET_ATTENDEE_TICKETING_ORDERS = gql`
query attendeeTicketingOrders($event_id: Int!, $uids: [String!]) {
  reports_transactions_ticketing(where: {event_id: {_eq: $event_id}, uid: {_in: $uids}}, order_by: {transaction_time: desc}) {
    card_type
    device_app_id
    digital_surcharge
    event_id
    event_name
    applied_discount_amount
    item_subtotal
    last4
    location_id
    location_name
    order_id
    order_items_count
    order_mx_ref_id
    order_status
    organization_id
    organization_name
    payment_ref_id
    payment_status
    payment_type
    applied_discount_name
    tax
    tip
    transaction_amount
    transaction_date
    transaction_hour
    transaction_status
    transaction_time
    uid
    attendee_id
    email
    username
    vendor_id
    vendor_name
  }
}
`;

export const GET_ATTENDEE_TICKETING_ORDERS_BY_ATTENDEE = gql`
query attendeeTicketingOrdersByAttendee($event_id: Int!, $attendeeId: Int!) {
  reports_transactions_ticketing(where: {event_id: {_eq: $event_id}, attendee_id: {_eq: $attendeeId}}, order_by: {transaction_time: desc}) {
    applied_discount_amount
    applied_discount_name
    attendee_id
    build_id
    card_type
    created_at
    device_app_id
    digital_surcharge
    discount_json
    email
    event_id
    event_name
    is_tab
    item_subtotal
    items_json
    last4
    location_id
    location_name
    order_id
    order_items_count
    order_mx_ref_id
    order_status
    organization_id
    organization_name
    payment_ref_id
    payment_status
    payment_type
    promo_code_uid
    tab_name
    tab_nickname
    tax
    tip
    total_promo_discount
    transaction_amount
    transaction_date
    transaction_hour
    transaction_status
    transaction_time
    uid
    username
    vendor_id
    vendor_name
  }
}
`;
